// Footer.js
import React from "react";
import "./footer.css"; // Import CSS for styling
import Icons from "../../config/images";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - Company Info */}
        <div className="footer-section-company-info">
          <h3>BA Code SOLUTIONS</h3>
          {/* Social Media Icons */}
          <div className="social-icons">
            <a href="#"><img className="fab-footer-icon" src={Icons.facebookIcon} /></a>
            <a href="#"><img className="fab-footer-icon" src={Icons.instagramIcon} /></a>
            <a href="#"><img className="fab-footer-icon" src={Icons.linkedInIcon} /></a>
          </div>
        </div>

        {/* Middle Section - Links */}
        <div className="footer-section links">
          <h4>Company</h4>
          <ul>
            <li><a href="#" className="footer-nav-link-style">About us</a></li>
            <li><a href="#" className="footer-nav-link-style">Contact us</a></li>
            <li><a href="#" className="footer-nav-link-style">Careers</a></li>
          </ul>
        </div>

        <div className="footer-section links">
          <h4>Services</h4>
          <ul>
            <li><a href="#" className="footer-nav-link-style">UI UX Designs</a></li>
            <li><a href="#" className="footer-nav-link-style">Mobile Application</a></li>
            <li><a href="#" className="footer-nav-link-style">Web Development</a></li>
          </ul>
        </div>

        <div className="footer-section links">
          <h4>Legal</h4>
          <ul>
            <li><a href="#" className="footer-nav-link-style">Privacy Policy</a></li>
            <li><a href="#" className="footer-nav-link-style">Terms & Conditions</a></li>
            <li><a href="#" className="footer-nav-link-style">Return Policy</a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
